import { DeleteFilled } from '@ant-design/icons';
import { Button, Col, Input, Row, Select, Space, Typography } from 'antd';
import Collapse from 'antd/lib/collapse';
import Form from 'antd/lib/form';
import { useForm } from 'antd/lib/form/Form';
import { get, isEmpty } from 'lodash';
import { any, arrayOf, bool, func, string } from 'prop-types';
import React, { useEffect, useState } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import useUploadFile from '../../hooks/useUploadFile';
import actions from '../../redux/actions';
import { notificationError } from '../../utils/Notification';
import dispatch from '../../utils/dispatch';
import { searchNonAccentVietnamese } from '../../utils/search';
import CustomizeCollapse from '../CustomizeCollapse';
import UploadImage from '../UploadImage';
import ArrowDownIcon from '../icons/ArrowDownIcon';
import ArrowUpIcon from '../icons/ArrowUpIcon';

const { Panel } = Collapse;

export default function WebsiteItem({
  id,
  name,
  domain,
  image,
  tags,
  icon,
  isNew,
  sale_off_message,
  brand,
  location,
  description,
  short_description,
  setShowAddWebsite
}) {
  const [expand, setExpand] = useState(false);
  const [file, handleUploadFile, handleReset] = useUploadFile(image);
  const listTags = useSelector(state => {
    return get(state, 'dealngon.tags', []);
  }, shallowEqual);
  const [form] = useForm();

  const iconObject = icon?.[0];

  useEffect(() => {
    form.setFieldsValue({ icon: iconObject?._id ? iconObject._id : icon });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [icon]);

  const listIcons = useSelector(state => {
    return get(state, 'dealngon.icons', []);
  });

  const handleDelete = e => {
    // call API delete
    dispatch(actions.updateWebsite({ _id: id, status: false }));
    e.stopPropagation();
  };

  const handleSave = values => {
    if (isEmpty(file.link)) {
      notificationError('Vui lòng nhập đầy đủ thông tin');
    } else if (isNew) {
      // call Create
      dispatch(
        actions.createWebsite({
          name: get(values, 'website_name', ''),
          domain: get(values, 'domain'),
          image: file.link ? file.link : image,
          icon: get(values, 'icon', null),
          tags: get(values, 'tags', []),
          sale_off_message: get(values, 'sale_off_message', ''),
          description: values?.description || '',
          short_description: values?.short_description || '',
          location: values?.location || 'USA',
          brand: values?.brand || ''
        })
      );
      setShowAddWebsite(false);
    } else {
      dispatch(
        actions.updateWebsite({
          name: get(values, 'website_name', ''),
          domain: get(values, 'domain'),
          icon: get(values, 'icon', null),
          image: file.link ? file.link : image,
          tags: get(values, 'tags', []),
          sale_off_message: get(values, 'sale_off_message', ''),
          _id: id,
          description: values?.description || '',
          short_description: values?.short_description || '',
          location: values?.location || 'USA',
          brand: values?.brand || ''
        })
      );
    }
  };

  const header = (
    <Row justify="space-between" align="middle">
      <Space align="center" size="middle">
        {expand ? <ArrowUpIcon /> : <ArrowDownIcon />}
        <Typography.Text strong>{isNew ? 'New Website' : domain}</Typography.Text>
      </Space>
      {!isNew && (
        <Col>
          <DeleteFilled onClick={handleDelete} />
        </Col>
      )}
    </Row>
  );

  return (
    <CustomizeCollapse
      onChange={() => {
        return setExpand(prevState => {
          return !prevState;
        });
      }}
    >
      <Panel header={header} showArrow={false}>
        <Form form={form} onFinish={handleSave}>
          <Row gutter={16}>
            <Col span={12}>
              <Typography.Text
                strong
                type="secondary"
                rules={[{ required: true, message: 'Vui lòng nhập domain' }]}
              >
                Domain
              </Typography.Text>
              <Form.Item name="domain" initialValue={domain}>
                <Input placeholder="Nhập domain" />
              </Form.Item>
              <Typography.Text strong type="secondary">
                Content
              </Typography.Text>
              <Form.Item name="website_name" initialValue={name}>
                <Input placeholder="Content" />
              </Form.Item>
              <Typography.Text strong type="secondary">
                Bao gồm Tags
              </Typography.Text>
              <Form.Item
                initialValue={tags.map(tag => {
                  return tag._id ? tag._id : tag;
                })}
                name="tags"
              >
                <Select
                  optionFilterProp="children"
                  filterOption={searchNonAccentVietnamese}
                  mode="multiple"
                  allowClear
                >
                  {listTags.map(({ _id, name: tagName }) => {
                    return <Select.Option key={_id}>{tagName}</Select.Option>;
                  })}
                </Select>
              </Form.Item>

              <Typography.Text strong type="secondary">
                Sale off
              </Typography.Text>
              <Form.Item name="sale_off_message" initialValue={sale_off_message}>
                <Input placeholder="Sale off" />
              </Form.Item>

              <Typography.Text strong type="secondary">
                Description
              </Typography.Text>
              <Form.Item name="description" initialValue={description}>
                <Input placeholder="Sale off" />
              </Form.Item>

              <Typography.Text strong type="secondary">
                Short description
              </Typography.Text>
              <Form.Item name="short_description" initialValue={short_description}>
                <Input placeholder="Sale off" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Typography.Text strong type="secondary">
                Brand name
              </Typography.Text>
              <Form.Item name="brand" initialValue={brand}>
                <Input placeholder="Brand" />
              </Form.Item>
              <Typography.Text strong type="secondary">
                Location
              </Typography.Text>
              <Form.Item name="location" initialValue={location}>
                <Select
                  style={{ width: 120 }}
                  options={[
                    { value: 'USA', label: 'Mỹ' },
                    { value: 'ESP', label: 'Tây Ban Nha' }
                  ]}
                />
              </Form.Item>
              <Typography.Text strong type="secondary">
                Logo
              </Typography.Text>
              <Form.Item
                name="icon"
                rules={[{ required: true, message: 'Vui lòng chọn tên của icon' }]}
              >
                <Select className="category-form-input">
                  {listIcons.map(({ image: imageIcon, _id }) => {
                    return (
                      <Select.Option key={_id} value={_id}>
                        <img src={imageIcon} alt="Icon" width="24px" />
                      </Select.Option>
                    );
                  })}
                </Select>
              </Form.Item>
              <Typography.Text strong type="secondary">
                Ảnh
              </Typography.Text>
              <UploadImage
                isPreventCrop
                imgUrl={file.link}
                beforeUpload={handleUploadFile}
                loading={file.isFetching}
                handleReset={handleReset}
                isNew={isNew}
              />
            </Col>
          </Row>
          <Row justify="center" style={{ marginTop: 8 }}>
            <Button htmlType="submit" type="primary">
              Save
            </Button>
          </Row>
        </Form>
      </Panel>
    </CustomizeCollapse>
  );
}

WebsiteItem.propTypes = {
  id: string,
  name: string,
  domain: string,
  image: string,
  tags: arrayOf(any),
  icon: arrayOf(any),
  isNew: bool,
  setShowAddWebsite: func,
  sale_off_message: string,
  description: string,
  short_description: string,
  brand: string,
  location: string
};

WebsiteItem.defaultProps = {
  id: '',
  name: '',
  domain: '',
  image: '',
  tags: [],
  icon: [],
  isNew: false,
  setShowAddWebsite: () => {},
  sale_off_message: '',
  description: '',
  short_description: '',
  brand: '',
  location: ''
};
